import React, { useEffect, useState } from 'react';
import BrandLogo from './BrandLogo';

const STORAGE_KEY = 'ld_mobile_welcome_seen_v1';

const MobileWelcomeScreen = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const hasSeen = window.localStorage.getItem(STORAGE_KEY);
    if (hasSeen === 'true') return;

    const isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    if (isMobile) {
      setShow(true);
    }
  }, []);

  const handleDismiss = () => {
    try {
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(STORAGE_KEY, 'true');
      }
    } catch (e) {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-dark-950">
      <video
        src={process.env.PUBLIC_URL + '/brand/1213.mov'}
        className="w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      />
      <div className="absolute inset-0 bg-dark-950/40" />

      <div className="absolute inset-x-0 bottom-0 p-6 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <BrandLogo sizeClass="h-8" />
          <span className="text-xs text-dark-300 uppercase tracking-widest">Welcome</span>
        </div>
        <button
          type="button"
          onClick={handleDismiss}
          className="px-5 py-2.5 rounded-xl bg-primary text-dark-950 text-sm font-semibold shadow-elevated hover:bg-primary-300 transition-colors"
        >
          Enter app
        </button>
      </div>
    </div>
  );
};

export default MobileWelcomeScreen;
